<template>
  <div>
    <header-bar>
      スプリット
    </header-bar>
    <div class="page-block">
      <revenue-share-sub-header :sub-header="currentStep === 2 ? step2HeaderText : headerText" />
      <split-information-link />
      <div class="page-block__inner">
        <release-step-area
          :index="currentStep"
          :is-revenue-page="true">
        </release-step-area>
        <div class="my-release-search-wrap">
          <revenue-share-top-section
            :title="releaseData.product.title"
            :img-src="releaseData.product.coverart_filepath"
            :artist-name="releaseData.product.artist_name"
            :release-type="releaseData.product.type"
            :date="releaseData.created_at" />
          <revenue-sharing-form
            v-if="showForm"
            :form-fields-data="[formFields]"
            :errors-data="[errors]"
            :tracks="[releaseData]"
            :release-type="releaseData.product.type"
            :percentage-error="[percentageError]"
            :percentage-data="percentage"
            @viewForm="viewForm" />
          <form
            v-if="!showForm"
            @submit.prevent="submitForm">
            <revenue-share-form-table
              :form="formFields" />
            <p class="form-btn-area-top"></p>
            <revenue-share-form-bottom-area
              :confirm-button="'スプリットを登録する'"
              :back-button="'編集画面へ戻る'"
              @submitForm="submitForm"
              @viewForm="viewForm" />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReleaseStepArea from '../Release/StepArea'
import HeaderBar from '../HeaderBar'
import SplitInformationLink from './SplitInformationLink'
import RevenueShareSubHeader from './RevenueShareSubHeader'
import RevenueShareTopSection from './RevenueShareTopSection'
import RevenueShareFormTable from './RevenueShareFormTable'
import RevenueShareFormBottomArea from './RevenueShareFormBottomArea'
import RevenueSharingForm from './RevenueSharingForm'

export default {
  name: 'Step2',
  components: {
    RevenueSharingForm,
    RevenueShareTopSection,
    SplitInformationLink,
    ReleaseStepArea,
    HeaderBar,
    RevenueShareSubHeader,
    RevenueShareFormTable,
    RevenueShareFormBottomArea,
  },
  data() {
    return {
      releaseData: {
        product: {
          coverart_filepath: '',
          title: '',
          artist_name: '',
          type: '',
        },
        titles: [{
          title: '',
        }],
      },
      errors: [{
        rate: '',
        email: '',
        role: '',
      }],
      formFields: [{
        rate: '',
        email: '',
        memo: '',
        role: {},
        product_disc_track_id: '',
        product_id: '',
        owner: '',
      }],
      showForm: true,
      currentStep: 2,
      productDiscTrackId: '',
      productId: '',
      disableSubmitButton: false,
      step2HeaderText: 'スプリット設定',
      headerText: 'スプリット設定内容確認',
      isMobileScreen: false,
      percentageError: '',
      percentage: [],
    }
  },
  mounted() {
    const { id } = this.$route.params
    const { productId } = JSON.parse(window.sessionStorage.getItem('split')) || {}
    // check whether current processing productId and id of query params match or not.
    if (!productId || parseInt(productId, 10) !== parseInt(id, 10)) {
      this.$router.push({ name: 'index' })
      return
    }
    this.productId = id
    this.getProductById(id)
  },
  methods: {
    async getProductById(id) {
      try {
        const { data } = await window.axios.get(`/api/client/products/${id}`)
        const [releaseData] = data.discs[0].tracks
        this.releaseData = releaseData
        this.productDiscTrackId = this.releaseData.id
        this.formFields[0].email = this.$store.state.auth.email
        this.formFields[0].owner = 1
        this.formFields[0].product_disc_track_id = this.productDiscTrackId
        this.formFields[0].product_id = this.productId
      } catch (e) {
        await this.$router.push('/client')
      }
    },
    viewForm(event) {
      if (event) {
        this.currentStep = 2
        this.showForm = true
      } else {
        this.showForm = false
        this.currentStep = 3
      }
    },
    async submitForm() {
      try {
        await window.axios.post('/api/client/revenueShare', this.formFields)
        await this.$router.push({
          name: 'revenue-share-registration-completion',
          query: {
            title: this.releaseData.product.title,
            type: this.releaseData.product.type,
            id: this.productId,
          },
        })
      } catch (error) {
        if (error.response.status === 422) {
          const { errors } = error.response.data
          this.formatValidationErrorsFromBackend(errors)
        }
      }
    },
    formatValidationErrorsFromBackend(errors) {
      this.showForm = true
      Object.keys(errors).forEach(key => {
        if (key === 'percentageError') {
          // eslint-disable-next-line prefer-destructuring
          this.percentageError = errors[key][0]
        } else {
          const index = parseInt(key.split('.')[0], 10)
          const field = key.split('.')[1]
          const errorMessage = errors[key][0]
          const err = this.errors[index]
          if (field === 'rate') {
            err.rate = errorMessage
          } else if (field === 'email') {
            err.email = errorMessage
          } else if (field === 'role') {
            err.role = errorMessage
          }
          this.errors.splice(index, 1, err)
        }
      })
    },
  },

}
</script>

<style scoped>

.c-btn {
  font-size: 1.8rem;
  min-width: 20px;
  padding: 17px 16px;
  margin-top: 25px;
  text-align: center;
  width: 40px;
}

.my-release-search-wrap {
  height: auto;
  display: block;
  background: white;
}

.c-btn-margin {
  margin-top: 0 !important;
}

table {
  width: -webkit-fill-available;
  margin: 10px 0;
  border-collapse: separate;
  border-spacing: 10px;
}

th, td {
  padding: 15px;
}

th {
  text-align: initial;
}

.my-release-search-wrap .form-wrap {
  padding: 0 10px;
}

.form-btn-area-top svg {
  height: 20px;
  width: 13px;
  margin-right: 10px;
  margin-top: 5px;
  color: white;
}

.my-release-search-wrap .form-group .form-label {
  width: 100px;
}

.form-btn-area-top button {
  color: black;
  font-weight: normal;
}

.form-btn-area-bottom {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 10px;
  flex-wrap: wrap;
}

.form-btn-area-bottom button {
  width: 422px;
  margin-top: 20px;
}

.form-group-large {
  width: 300px !important;
}

.form-item {
  position: relative;
}

.form-item p {
  position: absolute;
}

.row {
  margin-bottom: 14px;
}

.form-group {
  padding: 14px 0 !important;
}

td, th {
  padding: 4px 0px !important;
}

</style>
